const queryKeyFactory = {
  study: (studyId?: string) => ['study', studyId],
}

export default queryKeyFactory
